
<template>
  <div class="flex min-h-screen bg-primaryBg font-inter">
    <aside class="hidden md:block w-[294px] flex-shrink-0 bg-primaryBg text-primaryDark">
      <Sidebar />
    </aside>
    <div class="flex-grow">
      <main class="w-full">
        <TeamComponent />
      </main>
    </div>
  </div>
</template>
  
  <script>
  import TeamComponent from '@/components/team/TeamComponent.vue';
  import Sidebar from '@/components/SidebarComponent.vue';

  export default {
    name: 'TeamsView',
    components: {
        Sidebar,
        TeamComponent,
    },
    mounted() {
      window.scrollTo(0, 0);
      },
  }
  </script>
  
  <style scoped>
  </style>
  
